{
  const tabs = document.querySelectorAll('[data-tariffs-tab]');  
  
  if (tabs.length) {
    const toggles = document.querySelectorAll('[data-tariffs-toggle]');
    const table = document.querySelectorAll('[data-tarif]');
    let elem;  
    const toggleTableVisibility = (id) => {
	  elem = document.querySelector('[id='+id+']');
	  table.forEach((item) => {		
        if (('data-'+item.id) === id) {
		  if (elem.classList.contains('tariffs__arrow--up')) {			
			item.classList.add('tariffs__table--hidden');
			elem.classList.remove('tariffs__arrow--up');
			elem.classList.add('tariffs__arrow--down');						
		  } else {
			 item.classList.remove('tariffs__table--hidden');
			 elem.classList.add('tariffs__arrow--up');	
			 elem.classList.remove('tariffs__arrow--down');
		  }			
		} else {			
		  item.classList.add('tariffs__table--hidden');
		  toggles.forEach((toggle) => {
			if (toggle.id != id) {
			  toggle.classList.remove('tariffs__arrow--up');
			  toggle.classList.add('tariffs__arrow--down');
			}
		  });			
		}			
      });
    };
  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      toggleTableVisibility(toggle.id);	  
    });
  });
    [...tabs].forEach((tab) => {
      tab.addEventListener('click', () => {
        [...tabs].forEach((tab) => {
          tab.classList.remove('tariffs-tabs__item--active');
        });
      
        tab.classList.add('tariffs-tabs__item--active');
      })
    });
  
    const monthPrice = document.querySelectorAll('[data-month-price]');
    const yearPrice = document.querySelectorAll('[data-year-price]');
	const two = document.querySelectorAll('[data-two]');
    const monthPriceTrigger = document.querySelector('[data-tariffs-tab-month]');
    const yearPriceTrigger = document.querySelector('[data-tariffs-tab-year]');
  
    monthPriceTrigger.addEventListener('click', () => {
      [...yearPrice].forEach((item) => {
        item.style.display = 'none';
      });
    
      [...monthPrice].forEach((item) => {
        item.style.display = '';
      });
    });
  
    yearPriceTrigger.addEventListener('click', () => {
      [...monthPrice].forEach((item) => {
        item.style.display = 'none';
      });
    
      [...yearPrice].forEach((item) => {
        item.style.display = '';
      });
    });
  }
}
